import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function completedDocumentReducer(
  state = initialState.completedDocument,
  action
) {
  switch (action.type) {
    case types.LOAD_COMPLETED_DOCUMENT_SUCCESS:
      return action.completedDocument;
    case types.RESET_COMPLETED_DOCUMENT_SUCCESS:
      return initialState.completedDocument;
    default:
      return state;
  }
}
